Jelly.Interface.Get_Offset = function(Parameters) {
	var Parent_Offset, Child_Offset = 0;
	if ($(Parameters.Child).length)
		Child_Offset = $(Parameters.Child).offset().top;
	if ($(Parameters.Parent).length)
		Parent_Offset = $(Parameters.Parent).offset().top;

	return (Child_Offset - Parent_Offset);
};